<template>
  <div>
    
    <section class="contact-content blue-bg">
      <div class="container">
        <div class="contact-grid">
          <div class="contact-info">
            <img src="https://image-hanit.cdn.bcebos.com/sit/hly/file/20251112/1762932243758_8d17ed97398f49678df6cbac53c138f5.png" alt="预约洽谈" class="pimg02">
            <img src="https://image-hanit.cdn.bcebos.com/sit/hly/file/20251112/1762932197014_568e10bbd2fb4765879d2ad022335697.png" alt="预约洽谈" class="pimg01">
          </div>
          
          <div class="contact-form">
            <h2>预约洽谈</h2>
            <p class="text-tip">提交信息后，专属顾问将会在3个工作日内与您取得联系</p>
            <el-form
              ref="ruleFormRef"
              style="max-width: 600px"
              :model="ruleForm"
              :rules="rules"
              label-width="auto"
            >
              <el-form-item label="" prop="customerType">
                <el-select v-model="ruleForm.customerType" size="large" placeholder="客户类型">
                  <el-option v-for="item in customList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="linkman">
                <el-input v-model="ruleForm.linkman" size="large" placeholder="姓名" />
              </el-form-item>
              <el-form-item label="" prop="mobile" required>
                <el-col :span="14">
                  <el-input v-model="ruleForm.mobile" size="large" placeholder="手机号码">
                    <template #append>
                      <span v-if="timer" class="count-down">{{count}}s</span>
                      <span v-else class="get-code" @click="getCode">获取验证码</span>
                    </template>
                  </el-input>
                </el-col>
                <el-col class="text-center" :span="1"></el-col>
                <el-col :span="9">
                  <el-form-item label="" prop="smsCode" required style="margin: 0">
                    <el-input v-model="ruleForm.smsCode" size="large" placeholder="输入验证码" />
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="" prop="customerName">
                <el-input v-model="ruleForm.customerName" size="large" placeholder="学校名称或企业名称" />
              </el-form-item>
              <el-form-item label="" prop="demandInfo">
                <el-input v-model="ruleForm.demandInfo" type="textarea" :rows="4" placeholder="请输入您的需求" />
              </el-form-item>
              <div class="agree-box">
                <el-checkbox v-model="agree" label="提交即代表阅读并同意">提交即代表阅读并同意</el-checkbox><a href="/userAgreement" target="_blank">《用户协议》</a>和<a href="/privacyPolicy" target="_blank">《隐私政策》</a>
              </div>
              <el-form-item>
                <el-button type="primary" @click="submitForm()" class="submit-btn">
                  提交
                </el-button>
                <!-- <el-button @click="resetForm(ruleFormRef)">Reset</el-button> -->
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted} from 'vue'
import { usePageSeo } from '~/composables/useSeo'
import { useHttpApi } from '~/composables/useApi'
import { ElForm, ElFormItem, ElSelect, ElOption, ElInput, ElButton, ElCol, ElMessage, ElCheckbox} from 'element-plus'
import Banner from './compontents/banner.vue'
// 使用useHead替代usePageSeo避免middleware中的警告
usePageSeo({
  title: '预约洽谈-苏州瀚易特信息技术股份有限公司',
  description: '',
  keywords: '',
  url: 'consultation'
})

const { getDictApi, sendSmsCodeApi, submitTalkApi } = useHttpApi()

const customList = ref([])
const ruleFormRef = ref<InstanceType<typeof ElForm>>()
const ruleForm = ref({
  customerType: '',
  customerName: '',
  address: '',
  linkman: '',
  mobile: '',
  demandInfo: '',
  smsCode: ''
})
const rules = ref({
  customerType: [
    { required: true, message: '请选择客户类型', trigger: 'change' }
  ],
  linkman: [
    { required: true, message: '请输入姓名', trigger: 'blur' }
  ],
  customerName: [
    { required: true, message: '学校名称或企业名称', trigger: 'blur' }
  ],
  mobile: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
  ],
  demandInfo: [
    { required: true, message: '请输入需求信息', trigger: 'blur' }
  ],
  smsCode: [
    { required: true, message: '请输入验证码', trigger: 'blur' }
  ],
})
const agree = ref(false)
const timer = ref(null)
const count = ref(60)

const loading = ref(false)

// 获取客户类型
const fetchDict = async () => {
  const res = await getDictApi('company_customer_type')
  customList.value = res?.data?.data || []
}

// 获取验证码
const getCode = async () => {
  // 校验手机号码不为空并且是否合法
  if (!ruleForm.value.mobile) {
    ElMessage({ type: 'error', message: '请输入手机号码' })
    return
  }
  
  if (!/^1[3-9]\d{9}$/.test(ruleForm.value.mobile)) {
    ElMessage({ type: 'error', message: '请输入正确的手机号码' })
    return
  }
  
  try {
    await sendSmsCodeApi(ruleForm.value.mobile)
    if (timer.value) {
      clearInterval(timer.value)
    }
    timer.value = setInterval(() => {
      count.value--
      if (count.value === 0) {
        clearInterval(timer.value)
        timer.value = null
        count.value = 60
        return
      }
    }, 1000)
    ElMessage({ type: 'success', message: '验证码已发送，请注意查收！' })
  } catch (error) {
    ElMessage({ type: 'error', message: '获取验证码失败，请稍后重试。' })
  }
}

const submitForm = async () => {
  ruleFormRef.value?.validate(async (valid) => {
    if(valid) {
      if(agree.value === false) {
        ElMessage({ type: 'error', message: '请阅读并同意《用户协议》和《隐私政策》' })
        return
      }
      if (loading.value) return
      loading.value = true
      try {
        const res = await submitTalkApi(ruleForm.value)
        // 显示成功消息
        if(res?.data.code === 200) {
          // 重置表单
          ruleFormRef.value?.resetFields()
          if (timer.value) clearInterval(timer.value)
          timer.value = null
          count.value = 60
          ElMessage({ type: 'success', message: '提交成功，我们会尽快与您联系！' })
        }
        else {
          ElMessage({ type: 'error', message: res?.data.message || '提交失败，请稍后重试。' })
        }
      } catch (error) {
        ElMessage({ type: 'error', message: '提交失败，请稍后重试。' })
      } finally {
        loading.value = false
      }
    } else {
      console.log('error submit!!')
      return false;
    }
  })
}
onMounted(() => {
  fetchDict()
})
</script>

<style scoped lang="scss">
@use "sass:color";
@use "~~/assets/scss/main.scss" as *;

.contact-content {
  padding: 120px 0 50px;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
}

.contact-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 6rem;
  .pimg01 {
    width: 100%;
    height: auto;
  }
  
  .pimg02 {
    width: 320px;
    height: auto;
  }
}

.el-form-item {
  margin: 20px 0;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.info-icon {
  font-size: 2rem;
  margin-right: 1rem;
  min-width: 3rem;
}

.info-content {
  h4 {
    margin-bottom: 0.5rem;
    color: $dark-color;
  }
  
  p {
    color: $secondary-color;
    margin: 0;
  }
}
.contact-form {
  background: #fff;
  padding: 30px;
  border-radius: 0.5rem;
  h2 {
    margin-bottom: 10px;
    color: $dark-color;
  }
}

.agree-box {
  display: flex;
  align-items: center;
  font-size: 14px;
}


::v-deep(.el-form-item) {
  .el-input__wrapper, .el-select__wrapper, .el-textarea__inner,.el-input-group__append {
    background: #F3F4F5;
    box-shadow: none;
    padding: 18px 16px;
  }
  .el-input__wrapper, .el-textarea__inner,.el-input-group__append {
    padding: 6px 16px;
  }
  .el-input__inner, .el-select__placeholder.is-transparent {
    // color: rgba(0,0,0,0.6) !important;
  }
}
::v-deep.el-select-dropdown__item {
  padding-left: 16px !important;
}
.get-code {
  color: #50A0FF;
  cursor: pointer;
}

.submit-btn {
  width: 100%;
  height: auto;
  background: #50A0FF;
  color: #fff;
  padding: 14px 0;
  font-size: 16px;
  font-weight: bold;
}



@media (max-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .banner h1 {
    font-size: 2rem;
  }
  
  .info-item {
    flex-direction: column;
    text-align: center;
  }
  
  .info-icon {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }
}
</style>